// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import { Icon } from '@ta/styleguide.icon';
import styles from './BackButton.css';

type Props = {|
  iconName: string,
  label: string,
  disabled: boolean,
  onClick: () => mixed,
|};

/**
 * A button shown in  the upper-left corner of the modal. This navigates to the previous step, or
 * closes the flow if we're on the first step.
 */
const BackButton = ({ iconName, label, disabled, onClick }: Props) => (
  <button
    className={styles.backButton}
    onClick={() => onClick()}
    disabled={disabled}
    aria-label={label}
  >
    <Icon name={iconName} />
  </button>
);

export default BackButton;
